export default __webpack_public_path__ + "static/Why_Purple_Fibre-373883338253b566ba29ace39a5065f6.mp4";